import { Link } from "gatsby-plugin-intl";
import PropTypes from "prop-types";
import _noop from "lodash.noop";
import React from "react";
import { useServiceModalsContext } from "./context";

const ServiceLink = ({
  serviceKey,
  className,
  to,
  onClick = _noop,
  children,
  ...props
}) => {
  const servicesModal = useServiceModalsContext();
  const handleClick = e => {
    onClick(e);
    servicesModal.openModal(serviceKey);
  };

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Link {...props} onClick={handleClick} className={className} to={to}>
      {children}
    </Link>
  );
};

ServiceLink.propTypes = {
  serviceKey: PropTypes.string,
  className: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
};

export default ServiceLink;
